import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { getSpacing } from '../../../utils/spacing';
import { View } from 'react-native';

export type MainContentContainerOwnProps = {
    style?: StyleProp<ViewStyle>;
    children: React.ReactNode;
    testID?: string;
    flex?: number;
    disableRenderInContainer?: boolean;
};

export type MainContentContainerProps = MainContentContainerOwnProps;

export const mainContentPadding = getSpacing(8);

const MainContentContainer: React.FC<MainContentContainerProps> = (props) => {
    if (props.disableRenderInContainer) return props.children;

    return (
        <View
            style={[
                {
                    padding: mainContentPadding,
                    width: '100%',
                },
                props.flex ? { flex: props.flex } : {},
                props.style,
            ]}
            testID={props.testID}
        >
            {props.children}
        </View>
    );
};

export default React.memo(MainContentContainer);
